module.exports = __webpack_public_path__ + "media/images/icon__arrow-up-right@2x-cd3a52f489dc78f78d6d259bc4e8e368.png";